var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98975 21.1695H75.657M34.4566 38.3363V55.5031M48.1901 38.3363V55.5031M13.8565 21.1695H68.7902L63.3655 69.9919C63.1796 71.6721 62.3804 73.2246 61.121 74.3523C59.8616 75.4799 58.2305 76.1034 56.54 76.1032H26.1067C24.4162 76.1034 22.7851 75.4799 21.5257 74.3523C20.2663 73.2246 19.4671 71.6721 19.2812 69.9919L13.8565 21.1695ZM25.3411 11.3741C25.8964 10.1963 26.7752 9.20077 27.8749 8.5035C28.9746 7.80624 30.2499 7.43602 31.552 7.43604H51.0947C52.3974 7.43537 53.6734 7.80528 54.7738 8.50259C55.8742 9.19989 56.7535 10.1958 57.3091 11.3741L61.9235 21.1695H20.7232L25.3411 11.3741Z",
    className: "svgStroke",
    strokeWidth: 5.31617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsTrashCan);
export default __webpack_public_path__ + "static/media/akar-icons_trash-can.b3f5ffb9a5bf7c5093b93f444860348d.svg";
export { ForwardRef as ReactComponent };